import React from 'react';
import PropTypes from 'prop-types';
import css from './CwLabel.scss';
import cx from 'classnames';

const CwLabel = (props) => {
  if (props.isHTML) {
    return (
      <label
        data-cwid={props.cwId}
        htmlFor={props.htmlFor}
        style={props.style}
        tabIndex={props.isLink ? 0 : undefined}
        className={cx(props.className, {
          [css.underline]: props.underline,
          [css.clickable]: props.onClick,
          [css.bold]: props.bold,
          [css.italic]: props.italic,
          [css.podLabel]: props.isPodLabel,
          [css.disabled]: props.disabled,
          [css.invalid]: props.invalid,
          [css.link]: props.isLink
        })}
        onClick={props.onClick}
        onFocus={props.onFocus}
        onBlur={props.onBlur}
        dangerouslySetInnerHTML={{ __html: props.value }} />
    );
  }
  else {
    return (
      <label
        data-cwid={props.cwId}
        htmlFor={props.htmlFor}
        style={props.style}
        tabIndex={props.isLink ? 0 : undefined}
        className={cx(props.className, {
          [css.underline]: props.underline,
          [css.clickable]: props.onClick,
          [css.bold]: props.bold,
          [css.italic]: props.italic,
          [css.podLabel]: props.isPodLabel,
          [css.disabled]: props.disabled,
          [css.invalid]: props.invalid,
          [css.link]: props.isLink
        })}
        onClick={props.onClick}
        onFocus={props.onFocus}
        onBlur={props.onBlur}>
        {props.isHTML ? null : props.value}
        {props.isHTML ? null : props.children}
      </label>
    );
  }
};

CwLabel.propTypes = {
  /**
   * Connectwise element id to be used as unique identifier
   */
  cwId: PropTypes.string,
  /**
   * Value of label must be strings
   */
  value: PropTypes.string,
  /**
   * True to set innerHTML directly.
   * Make sure not to expose users to XSS attack
   */
  isHTML: PropTypes.bool,
  /**
   * Children of label must be strings
   */
  children: PropTypes.string,
  /**
   * Id of the element this label is for
   */
  htmlFor: PropTypes.string,
  /**
   * Allows custom styling
   */
  style: PropTypes.object,
  /**
   * Used for adding extra css
   */
  className: PropTypes.string,
  /**
   * Callback function fired when label is clicked
   */
  onClick: PropTypes.func,
  /**
   * Controls if label is underlined
   */
  underline: PropTypes.bool,
  /**
   * Controls if label is bold
   */
  bold: PropTypes.bool,
  /**
   * Controls if label is in italics
   */
  italic: PropTypes.bool,
  /**
   * Controls if label should have same styling as CwPodElement's label
   */
  isPodLabel: PropTypes.bool,
  /**
   * Controls if label should be styled as a link button
   */
  isLink: PropTypes.bool,
  /**
   * Controls if label is disabled, gets disabled styling
   */
  disabled: PropTypes.bool,
  /**
   * Controls if label is invalid, gets invalid styling
   */
  invalid: PropTypes.bool,
  /**
   * Callback function that is fired when the component is focused
   */
  onFocus: PropTypes.func,
  /**
   * Callback function that is fired when the component is blurred
   */
  onBlur: PropTypes.func
};

export default CwLabel;


// WEBPACK FOOTER //
// ./src/components/cwlabel/CwLabel.jsx